import { EditorState } from './types';

export const selectMediaInfo = (state: {editor: EditorState}) => state.editor.mediaInfo;
export const selectMedia = (state: {editor: EditorState}) => state.editor.media;
export const selectMediaFetchState = (state: {editor: EditorState}) => state.editor.mediaFetchState;
export const selectMediaSaveState = (state: {editor: EditorState}) => state.editor.mediaSaveState;